import React from 'react';

import { Alert, AlertColor } from '@mui/material';

import ApiError from '~/types/ApiError';

interface Props {
  error: unknown;
}

export default function ChatTraceError({ error }: Props) {
  let message = 'Unable to load this chat trace. Please try again.';
  let severity: AlertColor = 'error';

  if (error instanceof ApiError) {
    const body = error.responseBody;
    if (error.status === 403) {
      message = 'You don’t have access to this chat trace.';
      severity = 'warning';
    } else if (error.status === 404) {
      message = 'Chat not found.';
    } else if (
      error.status === 422 &&
      typeof body === 'object' &&
      body !== null &&
      'reason' in body &&
      body.reason === 'legacy_runtime'
    ) {
      message = 'Trace unavailable for this older chat.';
      severity = 'info';
    }
  }

  return <Alert severity={severity}>{message}</Alert>;
}
